import { render, staticRenderFns } from "./LabelGenEditor.vue?vue&type=template&id=3b5cbb3c"
import script from "./LabelGenEditor.vue?vue&type=script&lang=js"
export * from "./LabelGenEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b5cbb3c')) {
      api.createRecord('3b5cbb3c', component.options)
    } else {
      api.reload('3b5cbb3c', component.options)
    }
    module.hot.accept("./LabelGenEditor.vue?vue&type=template&id=3b5cbb3c", function () {
      api.rerender('3b5cbb3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelGen/LabelGenEditor.vue"
export default component.exports